import { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import {
  cityActionId,
  countryActionId,
  adminUserRoleListActionId,
  toastError,
  toastSuccess,
  roleListActionId,
  exhibitionActionId,
  hallActionId,
  stallActionId,
  HallZoneActionId,
} from "../../../utils/constants";
import Footer from "../../../common_components/Footer";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../utils/pagination";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import {
  getExhStallPossessionList_action,
  verifyStallPossessionQR_action,
  submitStallPossessionQR_action,
} from "../../../actions/admin_module_action/exhStallPossessionChecklist_action/exhStallPossessionChecklist_action";
import DatePicker from "react-datepicker";
import { DatePicker as AntdDatePicker } from "antd";
import { QrReader } from "react-qr-reader";
import { sendNoDues_action } from "../../../actions/admin_module_action/tax_invoice_action/tax_invoice_action";
import * as XLSX from 'xlsx';
import { mobileNoValidator } from "../../../utils/Validator";
import ImageCapture from '../../../utils/ImageCapture';
import Resizer from "react-image-file-resizer";
import { getAccountExitPassList_action, insertExitPassOTP_action, getDamageDetails_action, insertDamage_action, getExitPassPdf_action, verifyExitPassOTP_action, updateDamageApproveStatus_action, dismantleStallHM_action } from "../../../actions/admin_module_action/account_exit_pass_action/account_exit_pass_action";

const { RangePicker } = AntdDatePicker;

class StallPossessionChecklistList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stallPossessionChecklistList: [],
      isLoading: false,
      exhibitionList: [],
      roleList: [],
      CompanyName: "",
      RoleID: "",
      isOpen: false,
      deleteID: "",
      roleName: "",
      exhibitionID: sessionStorage.getItem("sessionExhibitionID"),
      currentPage: 1,
      exhibitionName: "",
      hallId: "",
      hallList: [],
      zoneId: "",
      zoneList: [],
      StatusID: 0,
      RegistrationNO: "",
      PossessionStartDate: "",
      PossessionEndDate: "",
      PossessionDate: "",
      StartDate: null,
      EndDate: null,
      isQrCode: true,
      QrCodeValue: "",
      isAllSelect: false,
      Stallpossessiontakenby: "",
      ExhRegistrationList: [],
      StatusList: [],
      isDisablePop: false,
      isHallManager:
        JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 16 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 25,
      StallpossessiontakenbyErr: "",
      isSearchOpen: false,
      ndcPendingCount: 0,
      PossessionTakenByMobileNo: '',
      PossessionTakenByMobileNoErr: '',
      showVideoModal: false,
      loginAccesslist: [],
      contractorList: [],
      damageRemark: '',
      damageDocPath1: [],
      damageDocName1: [],
      damageDocFile1: [],
      damageDocType1: [],
      damageDocPath2: [],
      damageDocName2: [],
      damageDocFile2: [],
      damageDocType2: [],
      damageDocPath3: [],
      damageDocName3: [],
      damageDocFile3: [],
      damageDocType3: [],
      selectedDamage: {},
      isAddDamage: false,
      damageList: [],
      exhId: '',
      remarkErr: '',
    };
    this.getStallPossessionChecklistList =
      this.getStallPossessionChecklistList.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.getFillList = this.getFillList.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.pollingTimer = null;
    // Criteria of the last executed search, replayed by the background refresh so it
    // can't pick up filter edits the user hasn't hit Search on yet
    this.lastQueryParams = null;
  }

  componentDidMount() {
    this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
    this.getFillList(exhibitionActionId, "", "", "", "", "");
    this.getFillList(adminUserRoleListActionId, "", "", "", "", "");
    this.getFillList(hallActionId, this.state.exhibitionID, "", "", "", "");

    console.log("this.props", this.props.location.state);
    this.setState(
      {
        exhibitionID:
          this.props.location.state != null &&
            this.props.location.state.ExhibitionID != null
            ? this.props.location.state.ExhibitionID
            : sessionStorage.getItem("sessionExhibitionID"),
        CompanyName:
          this.props.location.state != null &&
            this.props.location.state.CompanyName != null
            ? this.props.location.state.CompanyName
            : null,
        RegistrationNO:
          this.props.location.state != null &&
            this.props.location.state.RegistrationNO != null
            ? this.props.location.state.RegistrationNO
            : null,
        hallId:
          this.props.location.state != null &&
            this.props.location.state.hallId != null
            ? this.props.location.state.hallId
            : null,
        zoneId:
          this.props.location.state != null &&
            this.props.location.state.zoneId != null
            ? this.props.location.state.zoneId
            : null,
        StatusID:
          this.props.location.state != null &&
            this.props.location.state.StatusID != null
            ? this.props.location.state.StatusID
            : this.state.isHallManager
              ? 1
              : 0,
      },
      () => this.getStallPossessionChecklistList()
    );
    this.startPolling();
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  // Refresh the list every 15s in the background (no page reload, no loader flicker)
  startPolling() {
    this.stopPolling();
    this.pollingTimer = setInterval(() => {
      // Skip while the QR / possession modal is open so an in-progress allocation isn't disturbed
      if (this.state.isOpen || this.state.showVideoModal || document.hidden) {
        return;
      }
      this.getStallPossessionChecklistList(true);
    }, 15000);
  }

  stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
      this.pollingTimer = null;
    }
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
    const { } = this.state;
    this.setState({ isLoading: !flag ? false : true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          // country list
          if (actionID === exhibitionActionId) {
            this.setState({
              exhibitionList: data.data,
            });
          }
          if (actionID === adminUserRoleListActionId) {
            this.setState({
              roleList: data.data,
            });
          }
          if (actionID === hallActionId) {
            this.setState({ hallList: data.data });
          }

          if (actionID === HallZoneActionId) {
            this.setState({ zoneList: data.data });
          }
        }
        this.setState({ isLoading: false });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleSearch() {
    this.getStallPossessionChecklistList();
  }

  clearSearch() {
    this.setState(
      {
        exhibitionID: sessionStorage.getItem("sessionExhibitionID"),
        currentPage: 1,
        exhibitionName: "",
        CompanyName: "",
        hallId: "",
        hallList: [],
        zoneId: null,
        zoneList: [],
        StatusID: 0,
        RegistrationNO: "",
        PossessionDate: null,
        StartDate: null,
        EndDate: null,
      },
      () => {
        this.getFillList(hallActionId, this.state.exhibitionID, "", "", "", "");
        this.getFillList(
          stallActionId,
          this.state.exhibitionID,
          "",
          "",
          "",
          ""
        );
      }
    );
    setTimeout(() => {
      this.getStallPossessionChecklistList();
    }, 100);
  }

  // isSilent = background poll: keep the loader hidden, replay the last search and don't
  // reset the page, row selection or toast transient errors
  getStallPossessionChecklistList(isSilent = false) {
    const { isHallManager } = this.state;
    const params =
      isSilent && this.lastQueryParams
        ? this.lastQueryParams
        : {
          exhibitionID: this.state.exhibitionID,
          CompanyName: this.state.CompanyName,
          RegistrationNO: this.state.RegistrationNO,
          hallId: this.state.hallId,
          zoneId: this.state.zoneId,
          StatusID: this.state.StatusID,
          StartDate: this.state.StartDate,
          EndDate: this.state.EndDate,
        };
    this.lastQueryParams = params;
    const { StatusID } = params;

    if (!isSilent) this.setState({ isLoading: true });
    this.props
      .getExhStallPossessionList_action(
        params.exhibitionID,
        params.CompanyName,
        params.RegistrationNO,
        params.hallId,
        null,
        StatusID === 0 ? null : StatusID,
        params.StartDate,
        params.EndDate,
        params.zoneId
      )
      .then((data) => {
        if (data.error != 1) {
          this.setState({ contractorList: data.data.contractorList })
          // A background refresh must not clear rows the user has already ticked
          const previouslySelected = new Set(
            this.state.stallPossessionChecklistList
              .filter((item) => item.Is_Select)
              .map((item) => item.ExhRegistrationID)
          );
          data.data.data.map((item) => {
            item.Is_Select = isSilent && previouslySelected.has(item.ExhRegistrationID);
          });

          let filteredData = data.data.data;
          if (StatusID === 0) {
            filteredData = data.data.data
              .filter((item) => item.Status === null || item.Status === "NDC Pending")
              .sort((a, b) => {
                const dateA = a.ScheduledDate
                  ? new Date(a.ScheduledDate.split("-").reverse().join("-"))
                  : new Date(0);
                const dateB = b.ScheduledDate
                  ? new Date(b.ScheduledDate.split("-").reverse().join("-"))
                  : new Date(0);
                return dateA - dateB;
              });
          }
          var damageData = data.data.damageData
          for (var i = 0; i < filteredData.length; i++) {
            var damageIdarr = []
            var damageArr = []
            for (var j = 0; j < damageData.length; j++) {
              if (damageData[j].ExhRegistrationID == filteredData[i].ExhRegistrationID) {
                if (damageData[j].DamageDocumentID != null) {
                  if (!damageIdarr.includes(damageData[j].DamageDocumentID)) {
                    damageIdarr.push(damageData[j].DamageDocumentID)
                    damageData[j].imgArr = [damageData[j].DocumentPath]
                    damageArr.push(damageData[j])
                  } else {
                    for (var k = 0; k < damageArr.length; k++) {
                      if (damageData[j].DamageDocumentID == damageArr[k].DamageDocumentID) {
                        damageArr[k].imgArr.push(damageData[j].DocumentPath)
                      }
                    }
                  }
                }
              }
            }
            filteredData[i].damageArr = damageArr
          }

          const updateState = {
            stallPossessionChecklistList: filteredData,
            StatusList: data.data.statusList,
          };
          // Leave the page the user is on and the filter dropdowns alone on a background refresh,
          // only pulling the page back if the refreshed list no longer reaches it
          if (!isSilent) {
            updateState.currentPage = 1;
            updateState.hallId = isHallManager ? data.data.HallID[0]["HallID"] : "";
          } else {
            const lastPage = Math.max(1, Math.ceil(filteredData.length / 10));
            if (this.state.currentPage > lastPage) {
              updateState.currentPage = lastPage;
            }
          }
          if (StatusID === null || StatusID === 0) {
            updateState.ndcPendingCount = data.data.data.filter(
              (item) => item.Status === null || item.Status === "NDC Pending"
            ).length;
          }

          this.setState(updateState, () => {
            if (isHallManager && !isSilent) {
              this.getFillList(
                HallZoneActionId,
                this.state.exhibitionID,
                data.data.HallID[0]["HallID"],
                "",
                "",
                "",
                false
              );
            }
          });
          if (!isSilent) this.setState({ isLoading: false });
        } else {
          if (!isSilent) {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // exportStallPossessionChecklist() {
  //   const { stallPossessionChecklistList, isAllSelect, contractorList } = this.state;

  //   this.setState({ isLoading: true });
  //   const isChecked = stallPossessionChecklistList.some(item => item.Is_Select)
  //   // ✅ Proper map return
  //   const filteredData = stallPossessionChecklistList
  //     .filter(item => item.Status !== "No Show" && (isChecked ? item.Is_Select : true))
  //     .map(item => ({
  //       ...item,
  //       ScheduledDate: this.formatDate(item.ScheduledDate),
  //       Status: item.Status && item.Status != '-' ? item.Status : 'NDC Pending'
  //     }));
  //   const exclude = [
  //     "ExhRegistrationID",
  //     "ExhibitionID",
  //     "HallID",
  //     "HallZoneMappingID",
  //     "StallPossessionStatusID",
  //     "HallNo/StallNo",
  //     "CountryName",
  //   ];

  //   const exportData = filteredData.map(row =>
  //     Object.fromEntries(
  //       Object.entries(row).filter(([key]) => !exclude.includes(key))
  //     )
  //   );

  //   // ✅ Removed duplicate column
  //   const columnOrder = [
  //     "HallName",
  //     "Zone",
  //     "StallName",
  //     "ExhRegistrationNo",
  //     "ExhibitorCompanyName",
  //     "Stall Type",
  //     "ScheduledDate",
  //     "Status",
  //     "IssuedBy",
  //     "PossessionDateTime",
  //     "PossessionTakenBy",
  //   ];

  //   const finalExportData = exportData.map(row =>
  //     Object.fromEntries(
  //       columnOrder.map(key => [key, row[key] ?? ""])
  //     )
  //   );

  //   const worksheet = XLSX.utils.json_to_sheet(finalExportData);
  //   const workbook = XLSX.utils.book_new();

  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  //   XLSX.writeFile(workbook, "StallPossessionChecklist.xlsx");

  //   this.setState({ isLoading: false });
  // }

  exportStallPossessionChecklist() {
    const {
      stallPossessionChecklistList,
      contractorList,
    } = this.state;

    this.setState({ isLoading: true });

    try {
      const isChecked = stallPossessionChecklistList.some(
        (item) => item.Is_Select
      );

      const filteredData = stallPossessionChecklistList
        .filter(
          (item) =>
            item.Status !== "No Show" &&
            (isChecked ? item.Is_Select : true)
        )
        .map((item) => ({
          ...item,
          ScheduledDate: this.formatDate(item.ScheduledDate),
          Status:
            item.Status && item.Status !== "-"
              ? item.Status
              : "NDC Pending",
        }));

      // ============================================================
      // Group contractors by Exhibitor Registration Number
      // ============================================================

      const contractorGrouped = {};

      (contractorList || []).forEach((contractor) => {
        const exhibitorNo = (contractor.ExhRegistrationNo || "")
          .toString()
          .trim();

        if (!exhibitorNo) return;

        if (!contractorGrouped[exhibitorNo]) {
          contractorGrouped[exhibitorNo] = [];
        }

        contractorGrouped[exhibitorNo].push(contractor);
      });

      // ============================================================
      // Main exhibitor columns
      // ============================================================

      const columnOrder = [
        "HallName",
        "Zone",
        "StallName",
        "ExhRegistrationNo",
        "ExhibitorCompanyName",
        "Stall Type",
        "ScheduledDate",
        "Status",
        "IssuedBy",
        "PossessionDateTime",
        "PossessionTakenBy",
      ];

      // ============================================================
      // Create final export data
      // ============================================================

      const finalExportData = [];

      filteredData.forEach((row) => {
        const exhibitorNo = (row.ExhRegistrationNo || "")
          .toString()
          .trim();

        const contractors = contractorGrouped[exhibitorNo] || [];

        const exportRow = {};

        // Add exhibitor details
        columnOrder.forEach((key) => {
          exportRow[key] = row[key] ?? "";
        });

        // ==========================================================
        // Add contractor details against the same exhibitor
        // ==========================================================

        contractors.forEach((contractor, index) => {
          const suffix = index + 1;

          exportRow[`ServiceName ${suffix}`] =
            contractor.ServiceName || "";

          exportRow[`ContractorCompanyName ${suffix}`] =
            contractor.ContractorCompanyName || "";

          exportRow[`ContractorPersonName ${suffix}`] =
            contractor.ContractorPersonName || "";

          exportRow[`ContractorMobileNo ${suffix}`] =
            contractor.ContractorMobileNo || "";

          exportRow[`ContractorEmail ${suffix}`] =
            contractor.ContractorEmail || "";
        });

        finalExportData.push(exportRow);
      });

      // ============================================================
      // Create worksheet
      // ============================================================

      const worksheet = XLSX.utils.json_to_sheet(finalExportData);

      // ============================================================
      // Create workbook
      // ============================================================

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Sheet1"
      );

      // ============================================================
      // Export Excel
      // ============================================================

      XLSX.writeFile(
        workbook,
        "StallPossessionChecklist.xlsx"
      );
    } finally {
      this.setState({ isLoading: false });
    }
  }

  verifyStallPossessionQR(value) {
    const { exhibitionID } = this.state;
    this.setState({ isLoading: true });
    this.props
      .verifyStallPossessionQR_action(value, exhibitionID)
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            isLoading: false,
            QrCodeValue: value ? value.split("/") : "",
            isQrCode: false,
            ExhRegistrationList: data.data,
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
          this.setState({ isOpen: false, isQrCode: true })
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  submitStallPossessionQR() {
    const { Stallpossessiontakenby, ExhRegistrationList, PossessionTakenByMobileNo } = this.state;
    const array = [];
    ExhRegistrationList.map((item) => {
      if (item.isChecked) {
        array.push({
          ExhRegistrationID: item.ExhRegistrationID,
        });
      }
    });
    if (Stallpossessiontakenby != "" && PossessionTakenByMobileNo != '') {
      const mobileValidate = mobileNoValidator(PossessionTakenByMobileNo)
      if (mobileValidate) {
        this.setState({
          PossessionTakenByMobileNoErr: mobileValidate,
        });
        return toastError(mobileValidate)
      }
      this.setState({ isLoading: true });
      this.props
        .submitStallPossessionQR_action(Stallpossessiontakenby, array, PossessionTakenByMobileNo)
        .then((data) => {
          if (data.error != 1) {
            toastSuccess("Stall possession successfuly allocated");
            this.setState({
              isLoading: false,
              isOpen: false,
              isQrCode: true,
              Stallpossessiontakenby: "",
              PossessionTakenByMobileNo: "",
            });
            this.getStallPossessionChecklistList();
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (Stallpossessiontakenby == '' || Stallpossessiontakenby == null) {
        this.setState({
          StallpossessiontakenbyErr: "Please enter stall possession taken by name",
        });
      }
      if (PossessionTakenByMobileNo == '' || PossessionTakenByMobileNo == null) {
        this.setState({
          PossessionTakenByMobileNoErr: "Please enter stall possession taken by mobile no",
        });
      }

      toastError("Please enter mandatory feilds!");
    }
  }

  // Update Current Page
  updateItem(item) {
    const { stallPossessionChecklistList } = this.state;
    this.setState({ currentPage: item });
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = stallPossessionChecklistList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(
      stallPossessionChecklistList.length / recordsPerPage
    );
  }

  onCheckbox(e, ExhRegistrationID) {
    const { stallPossessionChecklistList } = this.state;
    stallPossessionChecklistList.map((item, i) => {
      if (item.ExhRegistrationID == ExhRegistrationID) {
        item.Is_Select = e.target.checked;
      }
    });
    const isAllCheck = stallPossessionChecklistList
      .filter((item) => item.Status != "-")
      .every((obj) => obj.Is_Select);
    this.setState({
      stallPossessionChecklistList: stallPossessionChecklistList,
      isAllSelect: isAllCheck,
    });
  }

  formatDate(dateString) {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }

  record(list) {
    const { isAllSelect, isHallManager } = this.state;
    return (
      // <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
      //     <thead>
      //         <tr>
      //             <th className="text-left">Exhibitor Registration NO</th>
      //             <th className="text-left">Exhibitor Company Name</th>
      //             <th className="text-center">Country</th>
      //             <th className="text-center">Hall Name</th>
      //             <th className="text-center">Stall Name</th>
      //             <th className="text-center">Pending/Total Checklist</th>
      //             <th className="text-center">Status</th>
      //             <th style={{ width: '60px' }} className="text-center"></th>

      //         </tr>
      //     </thead>
      //     <tbody>
      //         {
      //             list.length > 0 ? <>{
      //                 list.map((data, i) => (
      //                     <tr key={Math.random()}>
      //                         <td className="text-left">{data.ExhRegistrationNo || '-'}</td>
      //                         <td className="text-left">{data.ExhibitorCompanyName || '-'}</td>
      //                         <td className="text-center">{data.CountryName || '-'}</td>
      //                         <td className="text-center">{data.HallName || '-'}</td>
      //                         <td className="text-center">{data.StallName || '-'}</td>
      //                         <td className="text-center">{data.PendingChecklist || '-'}</td>
      //                         <td className="text-center">{data.Status || '-'}</td>
      //                         <td className="text-center">
      //                             <i className="fa fa-pencil" aria-hidden="true"
      //                                 onClick={(e) => this.handleUpdate(data.ExhRegistrationID, data.ExhibitionID)}

      //                             />

      //                         </td>
      //                     </tr>
      //                 ))}
      //             </> :
      //                 <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
      //         }
      //     </tbody>
      // </table>

      <table className="table sticky-table text-nowrap table-bordered mb-0">
        <thead className="table-light" style={{ position: "sticky", top: 0, zIndex: 20, backgroundColor: "#f8f9fa", outline: "1px solid #ddd", outlineOffset: "-1px" }}>
          <tr>
            {!isHallManager && (
              <th>
                <input
                  type="checkbox"
                  checked={isAllSelect}
                  onChange={(e) => {
                    const { stallPossessionChecklistList } = this.state;
                    stallPossessionChecklistList.map((item, i) => {
                      if (e.target.checked && item.Status != "-" && item.Status != "No Show") {
                        item.Is_Select = true;
                      } else {
                        item.Is_Select = false;
                      }
                    });
                    this.setState({
                      stallPossessionChecklistList:
                        stallPossessionChecklistList,
                      isAllSelect: e.target.checked,
                    });
                  }}
                />
              </th>
            )}
            <th className="text-center" style={{ minWidth: 50 }}>
              Hall
            </th>
            <th className="text-center">Zone</th>
            <th className="text-center">Stall</th>
            <th className="text-center">Booth Type</th>
            <th>Exhibitor</th>
            <th className="text-center">Scheduled Date</th>
            <th>Remark</th>
            <th className="text-center">Status</th>
            <th className="text-center">Issued By</th>
            <th className="text-center">Possession Date & Time</th>
            <th className="text-center">Possession Taken By</th>
            <th className="text-center">Taken By Mob. No.</th>
            <th className="text-center">Possession Given By</th>
            <th className="text-center">Mark Damage/View Damage</th>
            {!isHallManager && <th className="text-center">Action</th>}
          </tr>
        </thead>
        <tbody>
          {list.length > 0 ? (
            <>
              {list.map((data, i) => (
                <tr>
                  {!isHallManager && (
                    <>
                      {data.Status != "-" && data.Status != "No Show" && data.Status !== "NDC Pending" ? (
                        <td className="text-center hall-td">
                          <input
                            type="checkbox"
                            checked={data.Is_Select}
                            onChange={(e) =>
                              this.onCheckbox(e, data.ExhRegistrationID)
                            }
                          />
                        </td>
                      ) : (
                        <td className="text-center">-</td>
                      )}
                    </>
                  )}
                  <td className="text-center hall-td">
                    <strong className="fw-semibold">{data.HallName || "-"}</strong>
                  </td>
                  <td className="text-center">{data.Zone || "-"}</td>
                  <td className="text-center">{data.StallName || "-"}</td>
                  <td className="text-center">{data['Stall Type'] || "-"}</td>
                  <td>
                    <div>
                      <strong style={{ fontWeight: 600 }}>
                        {data.ExhRegistrationNo || "-"}
                      </strong>
                      <br />{" "}
                      <span style={{ fontSize: 14 }}>
                        {data.ExhibitorCompanyName || "-"}
                      </span>
                    </div>
                  </td>
                  <td className="text-center">
                    {this.formatDate(data.ScheduledDate)}{" "}
                  </td>
                  <td className="text-center" title={data.Remark}>
                    {data.Remark?.trim()?.length > 50
                      ? `${data.Remark.trim().slice(0, 50)}...`
                      : data.Remark?.trim() || "-"}
                  </td>
                  <td
                    className={`text-center text-aqua`}
                  >
                    {data.Status == 'NDC Pending' ?
                      <i class="fa fa-clock-o me-1 fs-6" /> :
                      data.Status == 'NDC Issued' ?
                        <i class="fa fa-file-text me-1 fs-6" /> :
                        data.Status == 'Stall Possession' ?
                          <i class="fa fa-check me-1 fs-6" /> :
                          data.Status == 'Possession Pending' ?
                            <i class="fa fa-hourglass-half me-1 fs-6" /> :
                            data.Status == 'No Show' ?
                              <i class="fa fa-exclamation-triangle me-1 fs-6" /> :
                              ""
                    }&nbsp;{data.Status}
                  </td>
                  <td className="text-center">{data.IssuedBy || "-"} </td>
                  <td className="text-center">{data.PossessionDateTime || "-"}</td>
                  <td className="text-center">{data.PossessionTakenBy || "-"}</td>
                  <td className="text-center">{data.PossessionTakenByMobileNo || "-"}</td>
                  <td className="text-center">
                    {data.PossessionGivenBy != null &&
                      data.PossessionGivenBy != " "
                      ? data.PossessionGivenBy
                      : "-"}
                  </td>
                  <td className="text-center">
                    <i style={{ cursor: 'pointer' }}
                      class={data.damageArr.length > 0 ? "bi bi-exclamation-triangle-fill text-aqua  p-1 pe-2 me-1" : "fa fa-exclamation-triangle  p-1 rounded-1 px-1 fw-normal pe-2 me-1 grid-icon"}
                      onClick={() => data.damageArr.length > 0 ?
                        this.setState({ isAddDamage: false, exhID: data.ExhRegistrationID, damageList: data.damageArr, damagePop: true, }) :
                        this.setState({ damagePop: true, exhID: data.ExhRegistrationID, isAddDamage: true, })}
                      title={data.damageArr.length > 0 ? "View Damage" : "Add Damage"}></i>
                  </td>
                  {!isHallManager && (
                    <td className="text-left">
                      {this.getUpdateAccess() && <i
                        className="fa fa-pencil"
                        aria-hidden="true"
                        title="Update"
                        onClick={(e) =>
                          this.handleUpdate(
                            data.ExhRegistrationID,
                            data.ExhibitionID,
                            data.Status
                          )
                        }
                      />}
                      {data.Status &&
                        data.Status.trim() !== "" &&
                        data.Status !== "-" &&
                        data.Status !== "No Show" && data.Status !== "NDC Pending" && this.getSendAccess() && (
                          <i
                            className="fa fa-share ml-2"
                            aria-hidden="true"
                            title="Share NoDue"
                            onClick={(e) =>
                              this.shareNoDues(
                                data.ExhRegistrationID,
                                data["SignatureUUID"]
                              )
                            }
                          />
                        )}
                    </td>
                  )}
                </tr>
              ))}
            </>
          ) : (
            <tr>
              <td colSpan={13} style={{ textAlign: "center" }}>
                Record not found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }

  handleUpdate(id, ExhibitionID, Status) {
    const {
      exhibitionID,
      CompanyName,
      RegistrationNO,
      hallId,
      zoneId,
      StatusID,
    } = this.state;
    if (exhibitionID == ExhibitionID) {
      this.props.navigate("/stallPossessionChecklistAU", {
        state: {
          ExhRegistrationID: id,
          ExhibitionID: exhibitionID,
          CompanyName: CompanyName,
          RegistrationNO: RegistrationNO,
          hallId: hallId,
          zoneId: zoneId,
          Status: Status,
        },
      });
    } else {
      this.props.navigate("/stallPossessionChecklistAU", {
        state: { ExhRegistrationID: id, ExhibitionID: ExhibitionID },
      });
    }
  }

  sendNoDues() {
    const { isLoading, stallPossessionChecklistList } = this.state;
    var selectedExhibitors =
      stallPossessionChecklistList.length > 0 &&
      stallPossessionChecklistList.filter((item) => item.Is_Select);
    if (selectedExhibitors.length > 0) {
      // exhibitor data Preparing to store
      var list = [];
      selectedExhibitors.map((data) => {
        var mapData = {
          ExhregistrationID: parseInt(data.ExhRegistrationID),
          hallStall: data["SignatureUUID"],
        };
        list.push(mapData);
      });
      this.setState({ isLoading: true });
      this.props
        .sendNoDues_action(list)
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            toastSuccess("No Dues Send");
            this.getExhibitorList();
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toastError("Select Atleast one Exhibitors");
    }
  }

  shareNoDues(ExhRegistrationID, SignatureUUID) {
    // exhibitor data Preparing to store
    var list = [];
    var mapData = {
      ExhregistrationID: ExhRegistrationID,
      hallStall: SignatureUUID,
    };
    list.push(mapData);
    this.setState({ isLoading: true });
    this.props
      .sendNoDues_action(list)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toastSuccess("No Dues Send");
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getWriteAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '43');
    if (moduleAccess) {
      return moduleAccess.WriteAccess;
    } else {
      return false
    }
    return false;
  }

  getUpdateAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '43');
    if (moduleAccess) {
      return moduleAccess.UpdateAccess;
    } else {
      return false
    }
    return false;
  }

  getDeleteAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '43');
    if (moduleAccess) {
      return moduleAccess.DeleteAccess;
    } else {
      return false
    }
    return false;
  }

  getDownloadAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '43');
    if (moduleAccess) {
      return moduleAccess.DownloadAccess;
    } else {
      return false
    }
    return false;
  }

  getSendAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '43');
    if (moduleAccess) {
      return moduleAccess.SendAccess;
    } else {
      return false
    }
    return false;
  }


  getSpecialAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '43');
    if (moduleAccess) {
      return moduleAccess.Is_SpecialAccess;
    } else {
      return false
    }
    return false;
  }

  handleCapture = (imageData) => {
    const { VendorIndex, camNp } = this.state
    if (camNp == 1) {
      this.setState({
        damageDocPath1: '',
        damageDocName1: 'Document1',
        damageDocFile1: imageData,
        damageDocType1: 'jpeg',
        damageDocErr: '',
      })
    }
    if (camNp == 2) {
      this.setState({
        damageDocPath2: '',
        damageDocName2: 'Document2',
        damageDocFile2: imageData,
        damageDocType2: 'jpeg',
        damageDocErr: '',
      })
    }
    if (camNp == 3) {
      this.setState({
        damageDocPath3: '',
        damageDocName3: 'Document3',
        damageDocFile3: imageData,
        damageDocType3: 'jpeg',
        damageDocErr: '',
      })
    }
    this.setState({ isImageModal: false })
  };



  renderNewImage = (img, type) => {
    const { imageBase64 } = this.state;
    if (type == 'pdf') {
      // window.open(img, "_blank")

      const base64 = img;
      const pdfData = atob(base64.split(",")[1]); // decode Base64

      const len = pdfData.length;
      const uintArray = new Uint8Array(new ArrayBuffer(len));
      for (let i = 0; i < len; i++) {
        uintArray[i] = pdfData.charCodeAt(i);
      }

      const blob = new Blob([uintArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      window.open(url, "_blank"); // open in new tab

    } else {
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(
          `<img src="${img}" style="width:100%;height:auto;" />`
        );
      } else {
        alert("Please allow popups for this website");
      }
    }
  };


  onFilePick = async (e, file, num) => {
    e.preventDefault()
    const { } = this.state
    console.log('file', file)
    if (file.length != 0) {
      if (file[0]['size'] >= 5 * 1024 * 1024) {
        toastError('File size more than 5mb are not allow.')
      } else {
        var image = '';
        if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
          file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
          file[0]['name'].toString().toLowerCase().includes('.png') ||
          file[0]['name'].toString().toLowerCase().includes('.jpg')
        ) {
          if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
            file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
            file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
          ) {
            if (num == 1) {
              image = await this.resizeFile(file[0]);
              this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
            } else if (num == 2) {
              image = await this.resizeFile(file[0]);
              this.setState({ damageDocFile2: image, damageDocName2: file[0]['name'].toString() })
            } else if (num == 3) {
              image = await this.resizeFile(file[0]);
              this.setState({ damageDocFile3: image, damageDocName3: file[0]['name'].toString() })
            }
          }
          else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
            image = await this.onPdfSelect(file[0]);
            if (num == 1) {
              this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
            } else if (num == 2) {
              image = await this.resizeFile(file[0]);
              this.setState({ damageDocFile2: image, damageDocName2: file[0]['name'].toString() })
            } else if (num == 3) {
              image = await this.resizeFile(file[0]);
              this.setState({ damageDocFile3: image, damageDocName3: file[0]['name'].toString() })
            }
          }
          var fileType = file[0]['type']
          var fileTypeList;
          if (fileType.includes("/")) {
            fileTypeList = fileType.split("/")

          }
          if (num == 1) {
            // this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
            this.setState({ damageDocType1: fileTypeList.length > 0 ? fileTypeList[1] : "", damageDocErr: '', })
          } else if (num == 2) {
            // this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
            this.setState({ damageDocType2: fileTypeList.length > 0 ? fileTypeList[1] : "", damageDocErr: '', })
          } else if (num == 3) {
            // this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
            this.setState({ damageDocType3: fileTypeList.length > 0 ? fileTypeList[1] : "", damageDocErr: '', })
          }
        } else {
          toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
        }
      }
    }
  }
  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        'JPEG',
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300,
      );
    });
  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        resolve(base64);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    });

  markAsDamage(isDamage) {
    const { isLoading, ExitNo, damageDocErr, damageDocFile1, ExhExitPassHdrID, damageDocFile2, damageDocFile3, damageDocName1, damageDocName2, damageDocName3, damageDocPath1, damageDocPath2, damageDocPath3, damageDocType1, damageDocType2, damageDocType3, damageRemark, HallId, ZoneId, isOpen, QrCodeImg, ExhRegistrationNo, ContractorCompanyName, CompanyName, isLastExitPass, vendorId, hallList, zoneList, accountExitPassList, currentPage, dismantlePop, exhID, damagePop } = this.state
    var Err = false
    var damagedocArr = []
    if (damageRemark == '' || damageRemark == null) {
      this.setState({
        remarkErr: 'Please enter Remark'
      })
      Err = true

    }
    if (damageDocFile1 != '' && damageDocFile1 != null) {
      damagedocArr.push({ damageDocPath: damageDocPath1, damageDocName: damageDocName1, damageDocFile: damageDocFile1, damageDocType: damageDocType1, Remark: damageRemark })
    }
    if (damageDocFile2 != '' && damageDocFile2 != null) {
      damagedocArr.push({ damageDocPath: damageDocPath2, damageDocName: damageDocName2, damageDocFile: damageDocFile2, damageDocType: damageDocType2, Remark: damageRemark })
    }
    if (damageDocFile3 != '' && damageDocFile3 != null) {
      damagedocArr.push({ damageDocPath: damageDocPath3, damageDocName: damageDocName3, damageDocFile: damageDocFile3, damageDocType: damageDocType3, Remark: damageRemark })
    }
    if (damagedocArr.length == 0) {
      this.setState({
        damageDocErr: 'Please enter atleast 1 image'
      })
      Err = true
    }
    if (Err) {
      toastError("Enter mandatory fields")
      return
    } else {
      this.setState({ isLoading: true, })
      this.props
        .insertDamage_action(exhID, '', isDamage ? damagedocArr : [], '', 0, [], 3, damageRemark)
        .then((data) => {
          if (data.error != 1) {
            this.setState({ dismantlePop: false, damagePop: false })
            this.setState({
              damageDocPath1: '',
              damageDocName1: '',
              damageDocFile1: '',
              damageDocType1: '',
              damageRemark: '',
              damageDocPath2: '',
              damageDocName2: '',
              damageDocFile2: '',
              damageDocType2: '',
              damageDocType3: '',
              damageDocName3: '',
              damageDocFile3: '',
              damageDocType3: '',
            })
            toastSuccess("Updated successfully")
            this.getStallPossessionChecklistList()
          }
        }).catch((e) => {
          console.log(e);
        });
    }
  }

  render() {
    const {
      isLoading,
      RegistrationNO, isAddDamage,
      damageRemark,
      damageDocPath1,
      damageDocName1,
      damageDocFile1, remarkErr,
      damageDocType1,
      damageDocPath2,
      damageDocName2,
      damageDocFile2,
      damageDocType2,
      damageDocPath3,
      damageDocName3,
      damageDocFile3,
      damageDocType3,
      exhibitionList, selectedDamage,
      currentPage,
      StatusID,
      CompanyName,
      stallPossessionChecklistList,
      exhibitionID,
      hallId,
      hallList, isImageModal,
      zoneId, damageList,
      zoneList,
      isQrCode,
      QrCodeValue,
      Stallpossessiontakenby,
      ExhRegistrationList,
      StatusList,
      isHallManager,
      StallpossessiontakenbyErr,
      PossessionTakenByMobileNo,
      PossessionTakenByMobileNoErr
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = stallPossessionChecklistList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(
      stallPossessionChecklistList.length / recordsPerPage
    );
    console.log(stallPossessionChecklistList, selectedDamage)
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />


        <div className="page">
          {!isHallManager && <AdminDrawer />}
          <div className="page-main">
            <div className="main-content app-content mt-0">
              <div
                className={
                  JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1
                    ? "with-dr-container"
                    : "with-dr-container com-height"
                }
                style={{
                  margin: isHallManager ? 0 : "",
                  marginTop: isHallManager ? 0 : "0px",
                }}
              >
                <div className="main-container">
                  <div className="row m-0">
                    <div className="breadcrumb-scroll-fixed">
                      <div className="position-relative">
                        <h6 className="mb-0 p-2 text-white">Stall Possession Checklist List</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="main-container p-2 pt-0 admin-top-space">
                  {this.state.showVideoModal && (
                    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => this.setState({ showVideoModal: false })}>
                      <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Stall Possession Checklist</h5>
                            <button type="button" className="btn-close" onClick={() => this.setState({ showVideoModal: false })}></button>
                          </div>
                          <div className="modal-body">
                            <video controls autoPlay style={{ width: '100%' }}>
                              <source src="/assets/StallPossessionChecklist.mp4" type="video/mp4" />
                            </video>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="d-flex justify-content-end mb-2">
                    {/* <span
                onClick={() => this.setState({ showVideoModal: true })}
                style={{ cursor: 'pointer', color: '#3dbca7', fontSize: '16px' }}
              >
                <i className="bi bi-play-circle-fill me-2"></i>User Manual
              </span> */}
                  </div>
                  <div className="row m-0">
                    <div className="accordion p-0" id="searchAccordion" style={{ width: "100%" }}>
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            onClick={() =>
                              this.setState({ isSearchOpen: !this.state.isSearchOpen })
                            }
                            style={{ fontSize: "16px !important" }}
                          >
                            Search Filters
                          </button>
                        </h2>
                        <div
                          className={`accordion-collapse collapse ${this.state.isSearchOpen ? "show" : ""
                            }`}
                        >
                          <div className="accordion-body">
                            <div className="row ">
                              <div className="col-xl-3 mb-3">
                                <label className="border-0">Exhibition</label>
                                <select
                                  className="form-control"
                                  value={exhibitionID}
                                  // disabled={isView}
                                  onChange={(e) =>
                                    this.setState(
                                      { exhibitionID: e.target.value },
                                      () => {
                                        this.getFillList(
                                          hallActionId,
                                          this.state.exhibitionID,
                                          "",
                                          "",
                                          "",
                                          "",
                                          false
                                        );
                                        // this.getFillList(stallActionId, this.state.exhibitionID, '', '', '', '');
                                      }
                                    )
                                  }
                                >
                                  {/* <option value={''}>Select</option> */}
                                  {exhibitionList.length > 0 &&
                                    exhibitionList.map((data) => (
                                      <option
                                        value={data.ExhibitionID}
                                        key={data.ExhibitionID}
                                      >
                                        {data.ExhibitionName}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              <div className="col-xl-3 mb-3">
                                <label className="border-0">Exhibitor Reg. No.</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  defaultValue=""
                                  maxLength={100}
                                  value={RegistrationNO}
                                  onChange={(e) =>
                                    this.setState({ RegistrationNO: e.target.value })
                                  }
                                />
                              </div>
                              <div className="col-xl-3 mb-3">
                                <label className="border-0">Exhibitor</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  defaultValue=""
                                  required=""
                                  maxLength={200}
                                  value={CompanyName}
                                  onChange={(e) =>
                                    this.setState({ CompanyName: e.target.value })
                                  }
                                />
                              </div>
                              <div className="col-xl-3 mb-3">
                                <label className="border-0">Hall</label>
                                <select
                                  className="form-control"
                                  id="roledb"
                                  value={hallId}
                                  disabled={isHallManager}
                                  onChange={(e) =>
                                    this.setState({ hallId: e.target.value }, () => {
                                      if (e.target.value != "") {
                                        this.getFillList(
                                          HallZoneActionId,
                                          this.state.exhibitionID,
                                          e.target.value,
                                          "",
                                          "",
                                          "",
                                          false
                                        );
                                      } else {
                                        this.setState({ zoneList: [] });
                                      }
                                    })
                                  }
                                >
                                  <option value={""}>Select</option>
                                  {hallList.length > 0 &&
                                    hallList.map((data) => (
                                      <option key={data.HallId} value={data.HallId}>
                                        {data.HallName}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              <div className="col-xl-3 mb-3">
                                <label className="border-0">Zone</label>
                                <select
                                  className="form-control"
                                  id="roledb"
                                  value={zoneId}
                                  onChange={(e) =>
                                    this.setState({ zoneId: e.target.value })
                                  }
                                >
                                  <option value={null}>Select</option>
                                  {zoneList.length > 0 &&
                                    zoneList.map((data) => (
                                      <option
                                        key={data.HallZoneMappingID}
                                        value={data.HallZoneMappingID}
                                      >
                                        {data.Zone}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              <div className="col-xl-6 mb-3">
                                <label className="border-0">Possession Date</label>
                                <div className="d-flex gap-2">
                                  <RangePicker
                                    style={{ height: "36px" }}
                                    format="DD-MM-YYYY"
                                    value={this.state.PossessionDate}
                                    onChange={(dates, dateStrings) => {
                                      this.setState({
                                        PossessionDate: dates,
                                        StartDate:
                                          dates && dates[0]
                                            ? dates[0].format("YYYY-MM-DD")
                                            : null,
                                        EndDate:
                                          dates && dates[1]
                                            ? dates[1].format("YYYY-MM-DD")
                                            : null,
                                      });
                                    }}
                                  />
                                  {JSON.parse(sessionStorage.getItem("loginDataSS"))
                                    .RoleID != 1 && (
                                      <>
                                        <button
                                          type="button"
                                          className="btn btn-aqua"
                                          onClick={(e) => this.handleSearch()}
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          Search
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-aqua"
                                          onClick={(e) => this.clearSearch()}
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          Clear
                                        </button>
                                      </>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`row ${isHallManager ? "" : ""
                    }`}>
                    <div className="col-md-12">
                      <div className="d-md-flex justify-content-between p-0  mb-1">
                        <div className="d-flex justify-content-left">
                          {!isHallManager && (
                            <>
                              <div className="p-2 mt-2">
                                <button
                                  disabled={!this.getSendAccess()}
                                  style={{ cursor: "pointer" }}
                                  type="button"
                                  className="btn btn-aqua"
                                  onClick={(e) => this.sendNoDues()}
                                >
                                  Send No Dues
                                </button>
                              </div>
                              {StatusID != 4 &&
                                <div className="p-2 px-0 mt-2">
                                  <button
                                    disabled={!this.getDownloadAccess()}
                                    style={{ cursor: "pointer" }}
                                    type="button"
                                    className="btn btn-aqua"
                                    onClick={(e) => this.exportStallPossessionChecklist()}
                                  >
                                    Export
                                  </button>
                                </div>
                              }
                            </>
                          )}
                        </div>
                        <div className="d-md-flex scroll-container align-items-center gap-1 p-2 py-0">
                          {/* Scan and give stall possession */}
                          <div
                            className={`"p-1 border-0 fw-semibold status-btn mt-0 me-2 ${isHallManager ? "" : ""
                              } `}
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.setState({ isOpen: true })}
                          >
                            <i className="fa fa-qrcode me-1 fs-6" style={{ border: "none" }} />
                            <span>Scan and give stall possession</span>
                          </div>
                          {/* All */}
                          <div
                            className="p-1 rounded-1 status-btn mb-2"
                            style={{
                              cursor: "pointer",

                            }}
                            onClick={() =>
                              this.setState({ StatusID: null }, () =>
                                this.getStallPossessionChecklistList()
                              )
                            }
                          >
                            <i class="fa fa-list  me-1 fs-6"></i>
                            <span>All:</span>
                            <strong
                              className="ms-1"
                              style={{ fontSize: 15 }}
                            >
                              {console.log("StatusList------->", StatusList)}
                              {StatusList.length > 0 &&
                                StatusList.reduce(
                                  (sum, item) => sum + item.StatusCount,
                                  0
                                )}
                            </strong>
                          </div>
                          {/* NDC Pending */}
                          <div
                            className="p-1 rounded-1 status-btn mb-2"
                            style={{
                              cursor: "pointer",
                              // border: "1px solid #333",
                              // backgroundColor:
                              //   this.state.StatusID === 0 ? "#f5f5f5" : "white",
                            }}
                            onClick={() =>
                              this.setState({ StatusID: 0 }, () =>
                                this.getStallPossessionChecklistList()
                              )
                            }
                          >
                            <i
                              class="fa fa-clock-o me-1 fs-6 "
                            >

                            </i>
                            <span >NDC Pending:</span>
                            <strong
                              className="ms-1"
                              style={{ fontSize: 15 }}
                            >
                              {this.state.ndcPendingCount}
                            </strong>
                          </div>
                          {/* Total Issued */}
                          <div
                            className="p-1 rounded-1 status-btn mb-2"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              this.setState({ StatusID: 1 }, () =>
                                this.getStallPossessionChecklistList()
                              )
                            }
                          >
                            <i class="fa fa-file-text me-1 fs-6"></i>
                            <span className="">NDC Issued:</span>
                            <strong
                              className="ms-1"
                              style={{ fontSize: 15 }}
                            >
                              {StatusList.length > 0 && StatusList[0]["StatusCount"]}
                            </strong>
                          </div>
                          {/* Total Taken */}
                          <div
                            className="p-1 rounded-1 status-btn mb-2"
                            style={{
                              cursor: "pointer"
                            }}
                            onClick={() =>
                              this.setState({ StatusID: 2 }, () =>
                                this.getStallPossessionChecklistList()
                              )
                            }
                          >
                            <i class="fa fa-check me-1 fs-6"></i>
                            <span>Stall Possession:</span>
                            <strong
                              className="ms-1"
                              style={{ fontSize: 15 }}
                            >
                              {StatusList.length > 0 && StatusList[1]["StatusCount"]}
                            </strong>
                          </div>
                          {/* Total Pending */}
                          <div
                            className="p-1 rounded-1 status-btn mb-2"
                            style={{
                              cursor: "pointer",

                            }}
                            onClick={() =>
                              this.setState({ StatusID: 3 }, () =>
                                this.getStallPossessionChecklistList()
                              )
                            }
                          >
                            <i
                              class="fa fa-hourglass-half me-1 fs-6"
                            ></i>
                            <span>Possession Pending:</span>
                            <strong
                              className="ms-1"
                              style={{ fontSize: 15 }}
                            >
                              {StatusList.length > 0 && StatusList[2]["StatusCount"]}
                            </strong>
                          </div>
                          {/* Total Possession Due */}
                          <div
                            className="p-1 rounded-1 status-btn mb-2"
                            style={{
                              cursor: "pointer",

                            }}
                            onClick={() =>
                              this.setState({ StatusID: 4 }, () =>
                                this.getStallPossessionChecklistList()
                              )
                            }
                          >
                            <i class="fa fa-exclamation-triangle me-1 fs-6"></i>
                            <span>No Show:</span>
                            <strong
                              className="ms-1"
                              style={{ fontSize: 15 }}
                            >
                              {StatusList.length > 0 && StatusList[3]["StatusCount"]}
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row m-0">
                    <div className="table-responsive service-list-grid p-0 ">
                      {this.record(currentRecords)}
                    </div>
                    <div className="m-2 mx-0 float-right trp p-0">
                      {stallPossessionChecklistList.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                      <div className="table-record-pages">
                        <p>{`${currentPage} of ${nPages} pages`}</p>
                      </div>
                    </div>
                  </div>
                </div>


                {!isHallManager && <Footer />}
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={this.state.isOpen}
          onRequestClose={(e) =>
            this.setState({ isOpen: false, isQrCode: true })
          }
        >
          <div className="modal-dialog modal-lg mt-0">
            <div className="modal-content">
              <div class="modal-header text-white p-2 rounded-top-4">
                <h6 class="modal-title">
                  <i class="ri-group-line me-2"></i> {isQrCode ? 'Scan QR Code' : 'Exhibitor List'}
                </h6>

                <div className="ms-auto d-flex align-items-center gap-3">
                  <button
                    type="button"
                    className="btn-close ms-2"
                    data-bs-dismiss="modal"
                    onClick={() => this.setState({ isOpen: false, isQrCode: true })}
                    style={{ fontSize: "16px !important" }}
                  />
                </div>
              </div>
              <div className="modal-body" style={{ background: "#f9fafb" }}>
                <div
                  className="col-12 pb-1"
                  style={{
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                  }}
                >
                  {isQrCode ? (
                    <QrReader
                      constraints={{ facingMode: "environment" }}
                      onResult={(result, error) => {
                        if (result) {
                          this.verifyStallPossessionQR(result?.text);
                        }
                        if (error) {
                          console.error(error);
                        }
                      }}
                      containerStyle={{
                        width: "50%",
                        height: "100%",
                        margin: "auto",
                      }} // 👈 use this
                      videoStyle={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <div>
                      <div
                        className="mb-0 card shadow-sm card-body d-flex flex-column"
                        style={{ height: "100%" }}
                      >
                        {/* Scrollable Exhibitor List */}
                        <div
                          className="overflow-auto pe-2 scrollable-list"
                          style={{ maxHeight: "50vh", paddingTop: "5px" }} // 👈 force scrolling region
                        >
                          {ExhRegistrationList.map((item) => (
                            <div
                              className="card mb-2 border-start border-4 border-warning shadow-sm rounded"
                              key={item.ExhRegistrationNo}
                              style={{ background: item.AllocationMessage ? '#f2f2f2' : undefined }}
                            >
                              <div
                                className="card-body py-2"
                                style={{
                                  boxShadow:
                                    "0 -4px 6px -5px rgba(0, 0, 0, 0.2)",
                                }}
                              >
                                <div className="row align-items-center">
                                  {/* Checkbox */}
                                  {!item.AllocationMessage &&
                                    <div className="col-1 mb-3 text-center">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={item.isChecked}
                                        disabled={item.AllocationMessage}
                                        onChange={() => {
                                          this.setState((prev) => {
                                            // 1. Toggle checkbox
                                            const updatedList = prev.ExhRegistrationList.map((i) =>
                                              i.ExhRegistrationNo === item.ExhRegistrationNo
                                                ? { ...i, isChecked: !i.isChecked }
                                                : i
                                            );

                                            // 2. Get checked items
                                            const checkedItems = updatedList.filter(i => i.isChecked);

                                            // 3. Decide values
                                            let Stallpossessiontakenby = '';
                                            let PossessionTakenByMobileNo = '';

                                            if (checkedItems.length === 1) {
                                              Stallpossessiontakenby = checkedItems[0].SP_PersonName || '';
                                              PossessionTakenByMobileNo = checkedItems[0].SP_ContactNo || '';
                                            }

                                            // 4. Return updated state
                                            return {
                                              ExhRegistrationList: updatedList,
                                              Stallpossessiontakenby,
                                              PossessionTakenByMobileNo,
                                            };
                                          });
                                        }}

                                      />
                                    </div>
                                  }
                                  {/* Exhibitor Details */}
                                  <div className="col-11">
                                    <p className="mb-1">
                                      <strong>Registration No:</strong>{" "}
                                      {item.ExhRegistrationNo}
                                    </p>
                                    <p className="mb-1">
                                      <strong>Company Name:</strong>{" "}
                                      {item.ExhibitorCompanyName}
                                    </p>
                                    <p className="mb-1">
                                      <strong>Country:</strong>{" "}
                                      {item.Country}
                                    </p>
                                    <p className="mb-1">
                                      <strong>Hall No:</strong>{" "}
                                      {item.HallName}
                                    </p>
                                    <p className="mb-0">
                                      <strong>Stall No:</strong>{" "}
                                      {item.StallName}
                                    </p>
                                    {item.AllocationMessage && (
                                      <p className="mb-0 text-danger">
                                        ({item.AllocationMessage})
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <label className="form-label">
                            Stall Possession Taken By
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control w-100"
                            value={Stallpossessiontakenby}
                            disabled={
                              !ExhRegistrationList.some(
                                (item) => item.isChecked
                              )
                            }
                            onChange={(e) =>
                              this.setState({
                                Stallpossessiontakenby: e.target.value,
                                StallpossessiontakenbyErr: "",
                              })
                            }
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {StallpossessiontakenbyErr}
                            </span>
                          }
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">
                            Stall Possession Taken By Mobile No
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control w-100"
                            maxLength={10}
                            value={PossessionTakenByMobileNo}
                            disabled={
                              !ExhRegistrationList.some(
                                (item) => item.isChecked
                              )
                            }
                            onChange={(e) =>
                              this.setState({
                                PossessionTakenByMobileNo: e.target.value.replace(/\D/g, ""),
                                PossessionTakenByMobileNoErr: "",
                              })
                            }
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {PossessionTakenByMobileNoErr}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer p-1">
                {!isQrCode && (
                  <button
                    type="button"
                    className="btn btn-aqua"
                    data-bs-dismiss="modal"
                    disabled={
                      !ExhRegistrationList.some((item) => item.isChecked)
                    }
                    onClick={(e) => this.submitStallPossessionQR(e)}
                  >
                    Submit
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-gray"
                  data-bs-dismiss="modal"
                  onClick={(e) =>
                    this.setState({ isOpen: false, isQrCode: true })
                  }
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal >
        <Modal
          isOpen={this.state.damagePop} onRequestClose={() => this.setState({ damagePop: false })}
        >
          {/* <div className="modal-dialog">
                                                                          <div className="modal-content confirm-logout">
                                                                              <div class="modal-header p-2">
                                                                                  <h5 class="modal-title">Additional Furniture</h5>
                                                                                  <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                                                                              </div>
                                                                              <div>
                                                                              </div>
                                                  
                                                                          </div>
                                                                      </div> */}

          {/* <div className="modal-dialog modal-xl modal-dialog-centered" style={{ marginLeft: '325px', marginTop: '60px' }}> */}

          {!this.state.isAddDamage ? <div class="modal-dialog modal-xl modal-dialog-centered" style={{ fontSize: 'larger' }}>
            <div className="modal-content shadow-lg border-0 rounded-4">
              <div class="modal-header bg-danger text-white py-2">
                <h5 class="modal-title" style={{ fontSize: "16px" }}>Damaged List</h5>
                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ damagePop: false })} ></button>
              </div>
              <div class="modal-body">
                <table class="table table-bordered table-striped">
                  <thead class="table-light">
                    <tr>
                      <th>Exhibitor Registartion No</th>
                      <th >Exhibitor Partner Details</th>
                      <th class="text-center">Damage Marked By</th>
                      {/* <th class="text-center">Damage From</th> */}
                      <th class="text-center">Damage Date</th>
                      <th style={{ width: '75px' }} class="text-center">View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {damageList.length > 0 ? damageList.map(item => (
                      <tr>
                        <td><span style={{ fontWeight: "600" }}>{item['ExhRegistrationNo'] != '' ? item['ExhRegistrationNo'] : ''}</span> {item['ExhRegistrationNo'] != null && item['ExhRegistrationNo'] != '' ? <br /> : ''}{item['ExhibitorName']}</td>
                        <td class="vendor p-1 ">
                          {<div style={{ lineHeight: '14px' }}>
                            {item['CompanyName'] != null && item['CompanyName'] != '' && <span class="my-1 mt-0  ha-view-com fw-bold"><i class="fa fa-solid text-dark fa-building"></i>&nbsp;
                              {item.CompanyName} </span>}
                            <br />
                            {item['PersonIncharge'] != null && item['PersonIncharge'] != '' && <span class="mt-0  ha-view-com" style={{ fontSize: "11px" }}><i class="fa fa-solid fa-user text-primary"></i>&nbsp; {item['PersonIncharge']} </span>}
                            <br />
                            {item['MobileNo'] != null && item['MobileNo'] != '' && <span class="mt-1" style={{ fontSize: "11px" }}> <i class="fa fa-solid fa-phone text-danger"></i>
                              &nbsp; {item['MobileNo']}  </span>}
                            <br />
                            {item['Email'] != null && item['Email'] != '' && <span style={{ fontSize: "11px" }}> <i class="fa fa-solid text-cyan fa-envelope"></i>
                              &nbsp; {item['Email']} </span>}
                            <br />
                          </div>}
                        </td>
                        <td class="text-center ">{item.DamageMarkedBy}</td>
                        {/* <td class="text-center ">{item.DamageFrom}</td> */}
                        <td class="text-center ">{moment(item.DamageDate).format('DD/MM/YYYY')}</td>
                        <td class="text-center">
                          {/* <a href="dd-return-entry"> */}
                          <i style={{ cursor: 'pointer' }} class="bi bi-eye grid-icon" onClick={() => this.setState({ selectedDamage: item, damagePop2: true })}></i>
                          {/* </a> */}
                        </td>
                      </tr>
                    )) : <tr>
                      <td colSpan={12} className="text-center">Record not found</td>
                    </tr>}
                  </tbody>
                </table >
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ damagePop: false })}>Cancel</button>
                <button type="button" class="btn btn-danger" onClick={() => this.setState({ isAddDamage: true })}>Add Damage</button>
              </div>
            </div>
          </div> : <div class="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content shadow-lg border-0 rounded-4">
              <div class="modal-header bg-danger text-white py-2">
                <h5 class="modal-title" style={{ fontSize: "16px" }}>Damaged Record</h5>
                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ damagePop: false })} ></button>
              </div>
              <div class="modal-body">
                <div>
                  Do you want to tag this stall as <strong>Damaged?</strong>
                </div>
                <div class="mb-2">
                  <label class="col-form-label">Remark<span class="text-danger">*</span></label>
                  <textarea
                    style={{ height: '100px !important' }}
                    id="damageRemark"
                    class="form-control"
                    rows="4"
                    placeholder="Enter reason here..."
                    onChange={(e) =>
                      this.setState({ damageRemark: e.target.value, remarkErr: "" })
                    }
                    value={this.state.damageRemark}
                  ></textarea>
                  <span className="text-danger text-start text-left d-block mt-1">
                    {remarkErr}
                  </span>
                </div>
                <div className='mb-1'>
                  <strong> Note: While taking pictures, please make sure that the booth name is clearly included and visible in photo.</strong>
                  < br />
                </div>
                <div class="card-body border rounded p-2">
                  <div class="row g-2 align-items-center">
                    <div class="col-md-12">
                      <label class="form-label mb-1">Capture / Upload the Damage photograph with identified landmark/ booth number</label>
                      {damageDocName1 != null && damageDocName1 != '' ? <div style={{
                        border: '1px solid #ccc',
                        padding: '10px',
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}>
                        <a
                          href={damageDocPath1}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {damageDocType1 != null && damageDocType1 != '' ? <span onClick={() => this.renderNewImage(damageDocFile1, damageDocType1)} style={{ marginRight: '10px', cursor: 'pointer' }}
                          >{damageDocName1}</span> : <span style={{ marginRight: '10px' }}
                          >{damageDocName1}</span>}
                        </a>
                        {<i className={`fa fa-times text-danger img-can`}
                          onClick={(e) => this.setState({ damageDocFile1: '', damageDocType1: '', damageDocName1: '', damageDocPath1: '' })}
                        ></i>}
                      </div>
                        : <div class="d-flex align-items-center gap-2">
                          {<button class="btn btn-aqua d-flex align-items-center" style={{ height: '27px' }} onClick={() => this.setState({ isImageModal: true, camNp: 1 })}>
                            <i class="bi bi-camera"></i> Open Camera
                          </button>}
                          {<span class="text-muted">or</span>}
                          {<div className="upload-options">
                            <label style={{ display: 'flex', margin: 0 }}>
                              <input
                                type="file"
                                id='fileDoc1'
                                ref='fileDoc1'
                                name='fileDoc1'
                                className="image-upload"
                                accept=".jpg, .jpeg, .png, .pdf"
                                onChange={e => this.onFilePick(e, e.target.files, 1)}
                              />
                            </label>
                          </div>}
                        </div>}
                    </div>
                  </div>
                </div>
                <div class="card-body border rounded p-2">
                  <div class="row g-2 align-items-center">
                    <div class="col-md-12">
                      <label class="form-label mb-1">Capture / Upload drivers photo along with vehicle number</label>
                      {damageDocName2 != null && damageDocName2 != '' ? <div style={{
                        border: '1px solid #ccc',
                        padding: '10px',
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}>
                        <a
                          href={damageDocPath2}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {damageDocType2 != null && damageDocType2 != '' ? <span onClick={() => this.renderNewImage(damageDocFile2, damageDocType2)} style={{ marginRight: '10px', cursor: 'pointer' }}
                          >{damageDocName2}</span> : <span style={{ marginRight: '10px' }}
                          >{damageDocName2}</span>}
                        </a>
                        {<i className={`fa fa-times text-danger img-can`}
                          onClick={(e) => this.setState({ damageDocFile2: '', damageDocType2: '', damageDocName2: '', damageDocPath2: '' })}
                        ></i>}
                      </div>
                        : <div class="d-flex align-items-center gap-2">
                          {<button class="btn btn-aqua d-flex align-items-center" style={{ height: '27px' }} onClick={() => this.setState({ isImageModal: true, camNp: 2 })}>
                            <i class="bi bi-camera"></i> Open Camera
                          </button>}
                          {<span class="text-muted">or</span>}
                          {<div className="upload-options">
                            <label style={{ display: 'flex', margin: 0 }}>
                              <input
                                type="file"
                                id='fileDoc1'
                                ref='fileDoc1'
                                name='fileDoc1'
                                className="image-upload"
                                accept=".jpg, .jpeg, .png, .pdf"
                                onChange={e => this.onFilePick(e, e.target.files, 2)}
                              />
                            </label>
                          </div>}
                        </div>}
                    </div>
                  </div>
                </div>
                <div class="card-body border rounded p-2">
                  <div class="row g-2 align-items-center">
                    <div class="col-md-12">
                      <label class="form-label mb-1">Capture / Upload any additional information or photos</label>
                      {damageDocName3 != null && damageDocName3 != '' ? <div style={{
                        border: '1px solid #ccc',
                        padding: '10px',
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}>
                        <a
                          href={damageDocPath3}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {damageDocType3 != null && damageDocType3 != '' ? <span onClick={() => this.renderNewImage(damageDocFile3, damageDocType3)} style={{ marginRight: '10px', cursor: 'pointer' }}
                          >{damageDocName3}</span> : <span style={{ marginRight: '10px' }}
                          >{damageDocName3}</span>}
                        </a>
                        {<i className={`fa fa-times text-danger img-can`}
                          onClick={(e) => this.setState({ damageDocFile3: '', damageDocType3: '', damageDocName3: '', damageDocPath3: '' })}
                        ></i>}
                      </div>
                        : <div class="d-flex align-items-center gap-2">
                          {<button class="btn btn-aqua d-flex align-items-center" style={{ height: '27px' }} onClick={() => this.setState({ isImageModal: true, camNp: 3 })}>
                            <i class="bi bi-camera"></i> Open Camera
                          </button>}
                          {<span class="text-muted">or</span>}
                          {<div className="upload-options">
                            <label style={{ display: 'flex', margin: 0 }}>
                              <input
                                type="file"
                                id='fileDoc1'
                                ref='fileDoc1'
                                name='fileDoc1'
                                className="image-upload"
                                accept=".jpg, .jpeg, .png, .pdf"
                                onChange={e => this.onFilePick(e, e.target.files, 3)}
                              />
                            </label>
                          </div>}
                        </div>}
                    </div>
                  </div>
                </div>
                {/* <span className="text-danger text-start text-left d-block mt-1">
                                                    {damageDocErr}
                                                </span> */}
                <span className="text-danger text-start text-left d-block mt-1">
                  Please upload atleast 1 image
                </span>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ damagePop: false })}>Cancel</button>
                {/* <button type="button" class="btn  btn-gray bg-secondary" onClick={() => this.markAsDamage(0, 2)}>Submit without Damage</button> */}
                <button type="button" class="btn btn-danger" onClick={() => this.markAsDamage(1)}>Submit Damage</button>
              </div>
            </div>
          </div>}
        </Modal>
        <Modal
          isOpen={this.state.damagePop2} onRequestClose={() => this.setState({ damagePop2: false })}
        >
          {/* <div className="modal-dialog">
                                                                                                              <div className="modal-content confirm-logout">
                                                                                                                  <div class="modal-header p-2">
                                                                                                                      <h5 class="modal-title">Additional Furniture</h5>
                                                                                                                      <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                                                                                                                  </div>
                                                                                                                  <div>
                                                                                                                  </div>
                                                                                      
                                                                                                              </div>
                                                                                                          </div> */}

          {/* <div className="modal-dialog modal-xl modal-dialog-centered" style={{ marginLeft: '325px', marginTop: '60px' }}> */}

          <div class="modal-dialog modal-xl modal-dialog-centered" style={{ fontSize: 'larger' }}>
            <div className="modal-content shadow-lg border-0 rounded-4">
              <div class="modal-header bg-danger text-white py-2">
                <h5 class="modal-title" style={{ fontSize: "16px" }}>Damaged Record</h5>
                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ damagePop2: false })} ></button>
              </div>
              <div class="modal-body">
                <div >
                  <strong style={{ fontSize: 'x-large' }}>{this.state.selectedDamage.ExhRegistrationNo}</strong><br />
                  <strong>{this.state.selectedDamage.PersonIncharge}</strong><br />
                  <strong>{this.state.selectedDamage.CompanyName}</strong><br />
                </div>
                <div>
                  Damage Marked By: <strong>{this.state.selectedDamage.DamageMarkedBy}</strong><br />
                  Damage Marked Date: <strong>{this.state.selectedDamage.DamageDate ? moment(this.state.selectedDamage.DamageDate).format('DD/MM/YYYY') : ''}</strong><br /><br />
                </div>
                <div>
                  Remark: <strong>{this.state.selectedDamage.DocumentRemark}</strong><br />
                </div>
                <div>
                  Images<br />
                  {this.state.selectedDamage.imgArr != undefined && this.state.selectedDamage.imgArr.length > 0 && this.state.selectedDamage.imgArr.map(item => (
                    <img
                      onClick={() => window.open(item, "_blank", "noopener,noreferrer")}
                      src={item}
                      style={{ margin: '2px', cursor: 'pointer' }}
                      alt="Preview"
                      width="200"
                      height="200"
                    />
                  ))}
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ damagePop2: false })}>Cancel</button>
              </div>
            </div>
          </div>
        </Modal>
        <ImageCapture
          isOpen={isImageModal}
          onClose={() => this.setState({ isImageModal: false })}
          onCapture={this.handleCapture}
        />
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getExhStallPossessionList_action,
    verifyStallPossessionQR_action, insertDamage_action,
    sendNoDues_action,
    submitStallPossessionQR_action,
  })(StallPossessionChecklistList)
);
